<template>
  <div class="page-wrapper compact-wrapper" id="pageWrapper">

    <div class="error-wrapper">
      <div class="container">
        <div class="svg-wrapper">
          <Error405Page />
        </div>
        <div class="col-md-8 offset-md-2">
          <h3>Page Not Found</h3>
          <p class="sub-content">The page you are attempting to reach is currently not available. This may be because the
            page does not exist or has been moved.</p><router-link class="btn btn-primary" :to="{ path: '/' }"> BACK TO
            HOME PAGE</router-link>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Error405Page from './svg/error405Page.vue'
export default {
  components: {
    Error405Page
  }
}
</script>